import { LucideIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

export const ColumnHeader = ({
  icon: Icon,
  label,
}: {
  icon: LucideIcon;
  label: string;
}) => {
  return (
    <Row className="items-center gap-1">
      <Icon className="h-4 w-4 text-slate-700" />
      <Text variant="header">{label}</Text>
    </Row>
  );
};
